export const loginCGO: any = {
  logoBroker: 'platform/logos/cgo.png',
  titulo: 'LOGIN.LANDING.MENSAJE',
  logoLogin: 'platform/logos/cgo.png',
  logoLogout: 'platform/backgrounds/logout.png',
  imagenes: [
    {
      carpeta: 'platform/backgrounds/REG1/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/REG2/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/REG3/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/Semana_1/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_2/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_3/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_4/',
      imagenes: 10
    },
  ]
}
export const loginGPTW: any = {
  logoBroker: 'platform/logos/gptw.jpg',
  titulo: 'LOGIN.LANDING.MENSAJE',
  logoLogin: 'platform/logos/cgo.png',
  logoLogout: 'platform/backgrounds/logout.png',
  imagenes: [
    {
      carpeta: 'platform/backgrounds/REG1/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/REG2/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/REG3/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/Semana_1/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_2/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_3/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_4/',
      imagenes: 10
    },
  ]
}
export const loginIZZI: any = {
  logoBroker: 'platform/logos/gptw.jpg',
  titulo: 'LOGIN.LANDING.MENSAJE',
  logoLogin: 'platform/logos/cgo.png',
  logoLogout: 'platform/backgrounds/logout.png',
  imagenes: [
    {
      carpeta: 'platform/backgrounds/izzi/',
      imagenes: 17
    }
  ]
}
export const loginOnSurvey: any = {
  logoBroker: 'platform/logos/onsurvey.png',
  titulo: '',
  logoLogin: '',
  logoLogout: '',
  imagenes: [
    {
      carpeta: 'platform/backgrounds/REG1/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/REG2/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/REG3/',
      imagenes: 7
    },
    {
      carpeta: 'platform/backgrounds/Semana_1/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_2/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_3/',
      imagenes: 10
    },
    {
      carpeta: 'platform/backgrounds/Semana_4/',
      imagenes: 10
    },
  ]
}
